import React from "react"
import AppRoute from "./domain/models/AppRoute"
import PageMain from "./view/pages/main/PageMain"
import Page404 from "./view/pages/_sys/Page404"
import PageProjects from "./view/pages/projects/PageProjects"


/**
 *  Массив маршрутов первого уровня
 *  @type {{ru: AppRoute[], en: AppRoute[]}}
 */
export const APP_ROUTES = {
    'en' : [
        new AppRoute({ path: '',                element: <PageMain/>,  }),
        new AppRoute({ path: '/projects/*',     element: <PageProjects/>,   link: '/projects',  label: 'Projects' }),
        // new AppRoute({ path: '',             element: <Navigate to='/main' /> }),
        new AppRoute({ path: '*',               element: <Page404/> }),
    ],
    'ru' : [
        new AppRoute({ path: '',                element: <PageMain/>,  }),
        new AppRoute({ path: '/projects/*',     element: <PageProjects/>,   link: '/projects',  label: 'Проекты' }),
        // new AppRoute({ path: '',             element: <Navigate to='/main' /> }),
        new AppRoute({ path: '*',               element: <Page404/> }),

    ]
}

export default APP_ROUTES